/** Збереження завантаженого файлу в браузері (Blob → тимчасове посилання → завантаження). */

/** Зберігає Blob під іменем `fileName`: тимчасове посилання на об'єкт, програмний клік, звільнення посилання згодом (не одразу — Firefox). */
export function saveFile(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  link.rel = 'noopener';
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 10_000);
}
